export const ACCOUNT_MAPPING: Record<string, string> = {
  '7xnyM3eU1yTsjMie4VTRXm': 'druck',
  'aofiyWQt9jjC1YsFUdEoAs': 'exagroup',
  'ca7c3Pxtzhrgm7i4obvTTh': 'tradeprint',
  'ozoDdrmewShEcbUDWX8J3V': 'vistaprint',
  'mUushi4JkEaX1E1bp3xSm7': 'buildasign',
  '4W1CB1YZxupiBsB5XExuc4': 'nationalpen',
  'p9h7ZCQf4m5AEeWDGq8zFT': 'wmd',
  'g2Ez5VaoZWoqU22XqPjTLU': 'cimpress',
  'sUwJnco1V7RtqbL6W8DuQ8': 'pixartprinting',
  'noS5wU4XH2WRmkaqKqTpfH': 'printdeal',
  'nonhZxAHRH4Z7PMWBKtwwC': 'boxup',
  'qwhj8J5SMLUVpVZbWyAriJ': 'printi',
  'm72TQHR2zkJY6yqWhH7vWE': 'cloudlab',
  'v3UZPLZhWm4uQTe4Nk6Sev': 'cimpressopen',
  'xu2HQoHLSAV1aSU571yCdn': 'cimpress'
};

export const getAccountNameFromId = (accountId: string | undefined): string => {
  if (!accountId || ACCOUNT_MAPPING[accountId] === undefined) {
    return '';
  }
  return ACCOUNT_MAPPING[accountId];
};
